<template>
    <div :class="parentClass">
        <div class="d-flex align-items-center">
            <div :class="step1StyleClasses">First let's pick a background color:</div>
            <div class="ms-2">
                <color-picker :color-object="newTheme.primary" color-field="bgColor" class="mt-1"
                              size-class="color-box-lg" @colorSelected="onBgColorSelected"></color-picker>
            </div>
        </div>

        <div v-if="newTheme.primary.bgColor" class="d-flex  align-items-center">
            <div :class="step2StyleClasses">Next let's pick a color for text:</div>
            <div class="ms-2">
                <color-picker :color-object="newTheme.primary" color-field="color" class="mt-1"
                              size-class="color-box-lg"></color-picker>
            </div>
        </div>

        <div v-if="newTheme.primary.color" class="d-flex  align-items-center">
            <div :class="step3StyleClasses">What color for a call to action?</div>
            <div class="ms-2">
                <color-picker :color-object="newTheme" color-field="ctaColor" class="mt-1" size-class="color-box-lg"></color-picker>
            </div>
        </div>

        <div v-if="newTheme.ctaColor">
            <div class="my-2">Now it is time to pick some fonts:</div>
            <div class="ms-2">
                <font-style-editor :font="newTheme.header_font" text-type="Header"></font-style-editor>
            </div>
            <div class="ms-2">
                <font-style-editor :font="newTheme.text_font" text-type="Text"></font-style-editor>
            </div>
        </div>

        <div v-if="newTheme.ctaColor" class="px-3 mb-2">
            <label class="form-label">Name</label>
            <input type="text" class="form-control" id="nameInput" placeholder="Theme name"
                   v-model="newTheme.name">
        </div>

        <div v-if="newTheme.ctaColor" class="my-3">
            <strong>Preview</strong>
        </div>
        <div v-if="newTheme.ctaColor" class="d-flex flex-column align-items-center p-3 rounded"
             :style="backgroundStyle(newTheme.primary)">
            <div>
                <h1 :style="getFontStyle(newTheme.header_font)">New Hand Crafted Theme</h1>
            </div>
            <div class="my-3 font-md" :style="getFontStyle(newTheme.text_font)">This theme is going to be gorgeous.</div>
        </div>
    </div>
</template>

<script>
import ColorUtil from "../utils/ColorUtil";
import FontStyleEditor from "./FontStyleEditor.vue";
import ColorPicker from "../components/ColorPicker.vue";

export default {
    name: 'NewThemeWizard',
    components: {ColorPicker, FontStyleEditor},
    props: ['newTheme', 'parentClass'],
    computed: {
        step1StyleClasses() {
            return this.newTheme.primary.bgColor ? 'fs-6 fw-normal' : 'fs-2 fw-bold'
        },
        step2StyleClasses() {
            return this.newTheme.primary.color ? 'fs-6 fw-normal' : 'fs-2 fw-bold'
        },
        step3StyleClasses() {
            return this.newTheme.ctaColor ? 'fs-6 fw-normal' : 'fs-2 fw-bold'
        }
    },
    data () {
        return {
            model: webase.model
        }
    },
    mounted () {
    },
    methods: {
        getFontStyle(fontStyleObject) {
            let weight = fontStyleObject.weight

            return {
                fontFamily: fontStyleObject.family,
                fontWeight: weight === 'regular' ? '400' : weight,
            }
        },
        backgroundStyle(backgroundObject) {
            return {
                backgroundColor: backgroundObject.bgColor,
                color: backgroundObject.color
            }
        },

        onBgColorSelected(color) {
            this.newTheme.name = 'My ' + ColorUtil.getColorName(color) + ' Theme'
        }
    }
}
</script>

<style>

</style>
